import React from 'react';
import { FileIcon } from 'elements/Icon';

const Audio = () => (
  <FileIcon>
    <path d="M98,2v136H2V2H98 M100,0H0v140h100V0L100,0z" />
    <rect x="12.8" y="24" width="74" height="4" />
    <rect x="12.8" y="36" width="74" height="4" />
    <rect x="12.8" y="48" width="74" height="4" />
    <rect x="12.8" y="60" width="74" height="4" />
    <rect x="12.8" y="72" width="74" height="4" />
    <rect x="12.8" y="84" width="54" height="4" />
  </FileIcon>
);

export default Audio;



// WEBPACK FOOTER //
// ./src/core/icons/components/files/types/Text.jsx